import { ApplicationResolution, ApplicationStatus } from "./Application";
export enum GigStatus {
  CREATED = "Created",
  IN_PROGRESS = "InProgress",
  CLOSED = "Closed",
}

export enum GigShiftStatus {
  UNDEFINED = "Undefined",
  AVAILABLE = "Available",
  INACTIVE = "Inactive",
}

export enum GigResolution {
  DONE = "Done",
  WITHDRAWN = "Withdrawn",
  NOT_FILLED = "NotFilled",
  CANCELLED = "Cancelled",
}

export enum GigShiftResolution {
  DONE = "Done",
  WITHDRAWN = "Withdrawn",
  NOT_FILLED = "NotFilled",
}

export enum GigType {
  PUBLIC = "Public",
  WORKPOOL = "Workpool",
  HIDDEN = "Hidden",
  STAFFING = "Staffing",
  WORKGROUP = "WorkGroup",
  UNIT = "Unit",
  SOLO = "Solo",
  AUTOGENERATED = "AutoGenerated",
}

export enum PaymentMethod {
  NONE = "None",
  SIMFLEXITY_PAY = "SimflexityPay",
  GIGAPAY = "Gigapay",
}

export type GigRating = {
  gigId: number;
  companyId: number;
  workerId: number;
  firstName: string;
  lastName: string;
  message: string;
  rating: number;
};

export type GigCostDto = {
  companyId: number;
  gigType: GigType | undefined;
  startTime: string;
  endTime: string;
  breakStartTime: string | undefined;
  breakEndTime: string | undefined;
  hourlyRate: number;
  workerId: number | null;
};

export type GigCosts = {
  grossSalary: number;
  obAmount: number;
  socialFee: number;
  simflexityFee: number;
  totalCost: number;
  vacationPayAmount: number;
};

/* New model for all gigs 2025 */
export type CompanyGig = {
  id: 0;
  companyId?: 0;
  location: string;
  type: GigType;
  role: string;
  description: string;
  minRate: number;
  maxRate: number;
  amountOfWorkers: number;
  status: GigStatus;
  resolution: GigResolution;
  paymentType: PaymentMethod;
  parentGigId: number;
  companyUnitId: number;
  workGroupId: number;
  startTime: string;
  endTime: string;
  createdAt: string;
  updatedAt: string;
  structure: CompanyGigStructure | null;
  skills: CompanyGigSkills[];
  shifts: CompanyGigShift[];
  applications: CompanyGigApplications[];
  useMonthlySalary?: boolean; //TODO: Arbeta bort denna
};

export type CompanyGigShift = {
  id?: number;
  gigId?: number;
  startTime: string;
  endTime: string;
  breakTime?: number;
  breakStartTime?: string | null;
  breakEndTime?: string | null;
  deductionAmount?: number;
};

export type CompanyGigApplications = {
  id: number;
  gigId: number;
  workerId: number;
  motivationalLetter: string;
  requestedRate: number;
  status: ApplicationStatus;
  resolution: ApplicationResolution;
  declineReason: string;
  worker: CompanyGigApplicationWorker;
};

export type CompanyGigApplicationWorker = {
  id: number;
  externalId: string;
  firstName: string;
  lastName: string;
};

export type CompanyGigSkills = {
  id?: number;
  gigId?: number;
  skill: string;
  experience: 0;
};

export type CompanyGigStructure = {
  workGroupId: number;
  workGroupName: string;
  companyUnitId: number;
  companyUnitName: string;
  companyEntityId: number;
  companyEntityName: string;
};
